export default __webpack_public_path__ + "static/media/clinical-app-4.542f557d.jpg";